const interval = setInterval(() => {
  const talonForm = document.querySelector('talon-form-ui');

  if (talonForm?.shadowRoot) {
    const style = document.createElement('style');

    style.textContent = `
        .talon-form-container {
            padding-block: 60px; 
        }
        .talon-form-container * {
            font-family: Poppins, sans-serif !important;
            font-weight: 400 !important;
        }
        .talon-form-stage-title{
            color: #121212;
        }
        section.talon-form-section {
            padding: 0;
        }
        .talon-form-stage-description>div {
            text-align: left !important;
            color: #121212;
        }
        .talon-field-input:focus {
            box-shadow: none;
            border-color: #121212;
        }
        .talon-field-input { 
            padding-block: .75rem;
            border-radius: 4px;
            margin-bottom: .65rem;
            color: #121212;
            border-color: #cdcdcd;
        }
        .talon-field-description {
            color: #121212b3;
        }
        .talon-field-description.talon-field-error {
            color: #ef4444;
            margin-top: 0;
        }
        .talon-form-container label {
            color: #121212;
        }
        .talon-form-actions,
        .talon-form-auxiliary-actions {
            padding-top: 0;
            justify-content: flex-start;
        }
        .talon-field-description:empty {
            display: none;
        }
        .talon-readonly-value {
            padding-block: .75rem;
            border-radius: 4px;
            margin-bottom: .65rem;
            color: #121212;
            border: 1px solid #cdcdcd;
        }
        .talon-readonly-value {
            padding-block: .75rem;
            padding-inline: 0.625rem;
            border-radius: 4px;
            margin-bottom: .65rem;
            color: #121212;
            border: 1px solid #cdcdcd;
            line-height: 1.25;
        }
        .talon-form-stage-description.talon-rich-content>div br {
            display: none;
        }
        button.talon-form-submit-secondary {
            background: #121212;
            color: #FFF;
            box-shadow: none;
            border-color: #121212;
        }
        button.talon-form-submit-secondary:is(:hover,:focus) {
            background: #121212;
        }
        .talon-form-section-title {
            font-size: 1rem;
        }
        .talon-field-textarea-wrapper.svelte-19ag0k3 {
            display: none;
        }
        .talon-field-label[for="field-Certificate"] {
            margin-top: .65rem;
        }
        section.talon-form-section {
            padding: 0;
            gap: .35rem;
        }
    `;
    talonForm.shadowRoot.appendChild(style);

    clearInterval(interval);
  }
}, 500);
